// @flow

import { PageType } from 'Constants';

export const Logo = {
  label: 'Markets Direct Website Home',
  url: `/`,
};

export const MobileCta = {
  [PageType.PRODUCT.NONE]: 'Make the most of your money with the solution that is right for you.',
  [PageType.PRODUCT.HELOC]: 'Get approved in 5 minutes and funding in 5 days.',
  [PageType.PRODUCT.MORTGAGE_REFI]: 'Quickly refinance your home loan with the option to cash-out.',
  [PageType.PRODUCT.SLR]: 'Make the most of your money with the solution that is right for you.',
};

export const Nav = [
  {
    title: 'Home',
    url: '/',
  },
  {
    title: 'Pricing',
    url: '/pricing',
    children: {
      title: 'Fees and Pricing',
      links: [
        {
          title: 'Futures',
          url: '/pricing',
        },
        {
          title: 'FX',
          url: '/fx',
        },
        {
          title: 'Equities',
          url: '/equities',
        },
        {
          title: 'Miscellaneous User Fees',
          url: '/fees',
        },
      ],
    },
  },
  {
    title: 'About',
    url: '/about',
    children: {
      title: 'About Us',
      links: [
        {
          title: 'Information and History',
          url: '/about',
        },
      ],
    },
  },
  {
    title: 'Trading',
    url: '/products',
    children: {
      title: 'Our Trading Environment',
      links: [
        {
          title: 'Products',
          url: '/products',
        },
        {
          title: 'Platforms',
          url: '/platforms',
        },
      ],
    },
  },
  {
    title: 'Services',
    url: '/b2b',
    children: {
      title: 'Our Services',
      links: [
        {
          title: 'B2B',
          url: '/b2b',
        },
      ],
    },
  },
  {
    title: 'Education',
    url: '/glossary',
    children: {
      title: 'Educational Resources',
      links: [
        {
          title: 'Glossary',
          url: '/glossary',
        },
      ],
    },
  },
  {
    title: 'Resources',
    url: '/regulatory',
  },
];
